export default __webpack_public_path__ + "static/foundation-f8833970ec42daa3b5923443d1ee5dd4.png";